const Background = () => (
  <div
    style={{
      zIndex: -1,
      width: "100vw",
      height: "100vh",
      position: "fixed",
      top: 0,
      left: 0,
      background: "black",
      opacity: "0.2",
    }}
  ></div>
);

export default Background;
